export const layouts = {
    'layout-00': '0',
    'layout-01': '1rem',
    'layout-02': '1.25rem',
    'layout-03': '2rem',
    'layout-04': '3rem',
    'layout-05': '4rem',
    'layout-06': '6rem',
    'layout-07': '10rem',
};
